module.exports = __webpack_public_path__ + "img/citas.7cd22bbb.png";